import { functional } from '@think-internet/zeus-frontend-package'
import useLoadPublicNAWSurvey from '../useLoadPublicNAWSurvey'
import { NAWSurvey } from '../../../../types/NAW/Survey'
import { useEffect, useState } from 'react'
import Routes from '../../../../redux/routes'
import { getRecommendedDeskSharingQuote } from '../../../Public/NAW/PageList/Summary/calculation'
import { PageType } from '../../../Public/NAW/NAW'

export type Update = (property: keyof NAWSurvey) => (value: any) => void
export type Save = (pageType: PageType) => Promise<boolean>
export enum Status {
  PENDING = 'PENDING',
  READY = 'READY',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

const useNAWSurveyAnswer = (nawSurveyUUID: string): [NAWSurvey, Update, Save, Status] => {
  const saveAnswerSet = functional.use(Routes.SAVE_NAW_ANSWER)
  const survey = useLoadPublicNAWSurvey(nawSurveyUUID)
  const [surveyAnswer, setSurveyAnswer] = useState<NAWSurvey>(null)
  const [status, setStatus] = useState<Status>(Status.PENDING)

  useEffect(() => {
    if (!surveyAnswer && !!nawSurveyUUID && !!survey && status === Status.PENDING) {
      const answer = { ...survey }
      setSurveyAnswer(answer)
    } else if (!!surveyAnswer && !!nawSurveyUUID && !!survey && status === Status.PENDING) {
      setStatus(Status.READY)
    } else if (!nawSurveyUUID && status === Status.PENDING && !surveyAnswer) {
      const answer = {}
      setSurveyAnswer(answer)
    } else if (!!surveyAnswer && !nawSurveyUUID && status === Status.PENDING) {
      setStatus(Status.READY)
    }
  }, [surveyAnswer, survey, status, nawSurveyUUID])

  const save: Save = async (pageType): Promise<boolean> => {
    if (!surveyAnswer.uuid) return true
    const result = await saveAnswerSet({ data: surveyAnswer, pageType })
    return !!result
  }

  const update: Update = (property: string) => (value: any) => {
    if (property === 'homeoffice' || property === 'collaborationPercentage') {
      const newSurveyAnswer: NAWSurvey = { ...surveyAnswer, [property]: value }
      setSurveyAnswer({ ...newSurveyAnswer, deskSharingPercentage: getRecommendedDeskSharingQuote(newSurveyAnswer) })
    } else {
      setSurveyAnswer({ ...surveyAnswer, [property]: value })
    }
  }

  return !!surveyAnswer ? [surveyAnswer, update, save, status] : [null, null, null, null]
}

export default useNAWSurveyAnswer
